module.exports = __webpack_public_path__ + "media/images/avatar-f4fd76ce45cb439bb6dfeb89437717f5.jpg";